import StatusBarElement from "@components/Layouts/StatusBar/StatusBarElement";
import styled from "@emotion/styled";
import NetworkConnectionWatcher from "@ext/errorHandlers/network/NetworkConnectionWatcher";
import t from "@ext/localization/locale/translate";
import type { CSSProperties } from "react";

interface OfflineProps {
	sourceInvalid?: boolean;
	isOffline?: boolean;
	style?: CSSProperties;
	className?: string;
}

const OfflineComponent = ({ style, className }: OfflineProps) => {
	const offline = t("sync-offline");
	const tooltipText = offline;
	const iconCode = "wifi-off";

	return (
		<span className={className} style={style}>
			<StatusBarElement
				className="sync-icons"
				iconCode={iconCode}
				iconStrokeWidth="1.6"
				onClick={() => NetworkConnectionWatcher.manualRetry()}
				tooltipText={tooltipText}
			/>
		</span>
	);
};

const Offline = styled(OfflineComponent)<OfflineProps>``;

export default Offline;
